/**
 * katexと通常文字列の混在型
 */
export type KatexMixedString = {
  /** latex式か否か */
  isKatex: boolean
  /** 文字列 */
  value: string
}

/**
 * 文字列に対するkatex関連処理群
 */
export default class KatexUtils {
  /** katex部分と判別するための囲い文字 */
  private static KATEX_ENCLOSURE = '$'

  /**
   * katex式が混在した文字列を分割して返す
   *
   * @param str 元文字列
   * @returns 分割した文字列データ
   */
  public static parse(str: string): KatexMixedString[] {
    // 結果配列生成
    const result: KatexMixedString[] = []

    // ループ内で、現在位置の文字がkatex扱いか否かのフラグ
    let isKatex = false
    // 切り出した一時文字列
    let parsedStr = ''

    for (let i = 0; i < str.length; i++) {
      // 囲い文字を発見した場合の処理
      if (str[i] === this.KATEX_ENCLOSURE) {
        // 切り出した文字列が存在する場合は結果配列に追加
        if (parsedStr) {
          const val = {
            isKatex: isKatex,
            value: parsedStr,
          }
          result.push(val)
        }

        // 切り出した文字列をリセットし、katexフラグを切り替えて次へ
        parsedStr = ''
        isKatex = !isKatex
        continue
      }

      // 囲い文字以外の場合は追加して次へ
      parsedStr = parsedStr.concat(str[i])
    }

    // ループ後、切り出した文字列が残っている場合は結果配列に追加
    if (parsedStr) {
      const val = {
        isKatex: isKatex,
        value: parsedStr,
      }
      result.push(val)
    }

    return result
  }
}
